/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEject = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 16v6H2v-6zm-2 2H4v2h16zM12 2l10 12H2zm0 2.99L6.245 12h11.51z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEject as Eject };
